import React from 'react';
import {
  Box,
  Button,
  ButtonVariant,
  Modal,
  Text,
} from '@usealloy/component-library';
import { snakeToCaps } from '~/helpers/formatting';
import { GRAY } from '~/constants';
import { formatMetadata } from './utils';

export type TransactionMetaModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  transactionMeta: Object;
};

const TransactionMetaModal: React.FC<TransactionMetaModalProps> = ({
  isOpen, closeModal, transactionMeta,
}) => (
  <Modal
    data-testid="transaction-meta-data-modal"
    header="Transaction Metadata"
    isOpen={isOpen}
    onClose={closeModal}
    primaryAction={
      (
        <Button
          onClick={closeModal}
          variant={ButtonVariant.primary}
        >
          Close
        </Button>
      )
    }
  >
    <Box gap={2} direction="column" style={{ padding: '0px 12px' }}>
      {transactionMeta && Object.entries(transactionMeta).map(([key, value], i) => (
        <Box
          justifyContent="space-between"
          key={`${key}-${value}`}
          style={{ background: (i % 2 === 1) ? GRAY.gray100 : 'none', wordBreak: 'break-word' }}
        >
          <Text style={{ width: '20%' }} size={3} weight={700}>{snakeToCaps(key)}</Text>
          <Text style={{ maxWidth: '80%' }} size={3}>{formatMetadata(value)}</Text>
        </Box>
      ))}
    </Box>
  </Modal>
);

export default TransactionMetaModal;
